<template>
  <div>
    <template>
      <div id="wrapper">

        <!-- Sidebar -- bg-gradient-danger -->
        <ul class="navbar-nav bg-gradient-engineer-re sidebar sidebar-dark accordion transitionToggled"
            :class="sidebarCollapse" id="accordionSidebar">

          <!-- Sidebar - Brand -->
          <a class="sidebar-brand d-flex align-items-center justify-content-center" href="#/">
            <div class="sidebar-brand-icon">
              <!-- rotate-n-15 -->
              <i class="fas fa-inbox"></i>
            </div>
            <div class="sidebar-brand-text my-3 mx-1"> JobFair x KMUTT</div>
          </a>

          <!-- Divider -->
          <hr class="sidebar-divider my-0">


          <!-- Nav Item - Dashboard -->
          <li class="nav-item" :class="filterActive === `all` ? `active` : ``">
            <a class="nav-link" @click="changeFilterActive(`all`)"><i
              class="fas fa-fw fa-list"></i><span>คำขอทั้งหมด</span>
            </a>
          </li>

          <!-- Divider -->
          <hr class="sidebar-divider">


          <!-- Nav Item - waiting -->
          <li class="nav-item" :class="filterActive === `pending` ? `active` : ``">
            <a class="nav-link" @click="changeFilterActive(`pending`)"><i
              class="fas fa-fw fa-pause-circle"></i><span>รอการอนุมัติ</span>
            </a>
          </li>

          <!-- Nav Item - approve -->
          <li class="nav-item" :class="filterActive === `approve` ? `active` : ``">
            <a class="nav-link" @click="changeFilterActive(`approve`)"><i
              class="fas fa-fw fa-check-circle"></i><span>อนุมัติ</span>
            </a>
          </li>

          <!-- Nav Item - reject -->
          <li class="nav-item" :class="filterActive === `reject` ? `active` : ``">
            <a class="nav-link" @click="changeFilterActive(`reject`)"><i
              class="fas fa-fw fa-times-circle"></i><span>ไม่อนุมัติ</span>
            </a>
          </li>

          <!-- Divider -->
          <hr class="sidebar-divider d-none d-md-block">


          <!-- Sidebar Toggler (Sidebar) -->
          <div class="text-center d-none d-md-inline">
            <button class="rounded-circle border-0" id="sidebarToggle" @click="toggled(!sidebarCollapseValue)"></button>
          </div>

        </ul>
        <!-- End of Sidebar -->

        <!-- Content Wrapper -->
        <div id="content-wrapper" class="d-flex flex-column">

          <!-- Main Content -->
          <div id="content">

            <!-- Topbar -->
            <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

              <!-- Topbar Navbar -->
              <div class="navbar-nav ml-auto">
                <b-nav class="d-flex justify-content-center align-items-center">
                  <b-nav-item href="#/"><span class="mr-2 d-none d-lg-inline text-gray-600">หน้าหลัก</span></b-nav-item>
                  <div class="topbar-divider d-none d-sm-block"></div>
                  <b-nav-item-dropdown class="no-arrow" right>

                    <template v-slot:button-content>
                      <a class="nav-link dropdown-toggle nav-link-custom"><i
                        class="fas fa-user-circle mr-2 text-gray-600"></i>
                        <span class="mr-2 d-none d-lg-inline text-gray-600">{{getKmuttId}}</span></a>
                    </template>
                    <b-dropdown-item class="nav-link" @click="kmuttUserLogout"><i
                      class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> Logout
                    </b-dropdown-item>
                  </b-nav-item-dropdown>
                </b-nav>

              </div>
            </nav>

            <!-- Begin Page Content -->
            <div class="container-fluid mt-4">
              <!-- Content Row -->
              <div class="row">
                <fade-transition :duration="100" origin="center top" mode="out-in">
                  <router-view :filter="filterActive"/>
                </fade-transition>
              </div>

            </div>
            <!-- /.container-fluid -->

          </div>
          <!-- End of Main Content -->

          <!-- Footer -->
          <footer id="sticky-footer" class="sticky-footer py-2 bg-dark text-white-50">
            <div class="container my-auto">
              <div class="copyright text-center my-auto">
                <p class="my-2">Copyright &copy; 2022, Faculty of Engineering KMUTT</p>
              </div>
            </div>
          </footer>
          <!-- End of Footer -->

        </div>
        <!-- End of Content Wrapper -->

      </div>
    </template>

  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "publicLayout",
    props: {
      isBackend: Boolean,
      isCompany: Boolean
    },
    data() {
      return {
        handleNavScroll: "",
        handleTextColorScroll: "",
        handleLinkScroll: "",
        sidebarCollapse: "",
        sidebarCollapseValue: false,
        dropdownAccount: false,
        filterActive: "all"
      }
    },
    computed: {
      ...mapGetters(["getKmuttId"])
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      ...mapActions(["kmuttLogout"]),
      changeFilterActive(filter) {
        this.filterActive = filter
      },
      kmuttUserLogout() {
        this.kmuttLogout()
          .then(() => {
            this.$router.push({path: "/"})
          })
      },
      handleScroll() {
        // Any code to be executed when the window is scrolled
        // eslint-disable-next-line no-empty
        if (window.scrollY > 95) {
          this.handleNavScroll = `navbar-light bg-light`;
          this.handleTextColorScroll = `handleTextColorScroll`;
          this.handleLinkScroll = `handleLinkScroll`
        } else {
          this.handleNavScroll = ``;
          this.handleTextColorScroll = ``
          this.handleLinkScroll = ``
        }
      },
      toggled(toggleValue) {
        this.sidebarCollapseValue = toggleValue;
        if (toggleValue) {
          this.sidebarCollapse = `toggled`
        } else {
          this.sidebarCollapse = ``
        }
      },
    }
  }
</script>

<style scoped>
  a.nav-link {
    cursor: pointer !important;
  }

  .transitionToggled {
    transition: 0.1s;
  }

  .handleTextColorScroll {
    color: rgba(0, 0, 0, 0.9);
    transition: 0.1s;
  }

  .nav-link.handleLinkScroll, .nav-link.dropdown-toggle {
    color: rgba(0, 0, 0, 0.5);
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.handleLinkScroll:hover, .nav-link.handleLinkScroll:focus {
    color: rgba(0, 0, 0, 0.9) !important;
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.active.handleLinkScroll {
    color: rgba(0, 0, 0, 0.9);
    transition: 0.1s;
    cursor: pointer;
  }

  .nav-link.btn {
    color: #FFFFFF;
    cursor: pointer;
  }

  .nav-link.btn:hover {
    color: #FFFFFF;
    cursor: pointer;
  }

  .nav-item .nav-link {
    height: auto;
  }
</style>
<style>
  .handleTextColorScroll:hover, .handleTextColorScroll:focus {
    color: rgba(0, 0, 0, 0.9) !important;
  }

  .dropdown-item.active, .dropdown-item:active {
    color: rgba(0, 0, 0, 0.9);
    background-color: transparent !important;
  }

  .nav-link {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }

  .center-fair {
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>
